import { useMemo } from "react";
import Slider from "react-slick";

export default function LyftTeamlogo({heading=false, newClass=""}) {
  const teamLogos = [
    "/assets/home/client-logo-dynamic-1.webp",
    "/assets/home/client-logo-dynamic-2.webp",
    "/assets/home/client-logo-dynamic-3.webp",
    "/assets/home/client-logo-dynamic-4.webp",
    "/assets/home/client-logo-dynamic-5.webp",
    // "/assets/home/lyft-team-logo-1.webp",
    // "/assets/home/lyft-team-logo-2.webp",
    // "/assets/home/lyft-team-logo-3.webp",
    // "/assets/home/lyft-team-logo-4.webp",
    "/assets/home/lyft-team-logo-5.webp",
    // "/assets/home/lyft-team-logo-6.webp",
    // "/assets/home/lyft-team-logo-7.webp",
    "/assets/home/lyft-team-logo-8.webp",
    "/assets/home/lyft-team-logo-9.webp",
    "/assets/home/lyft-team-logo-10.webp",
  ];

  const settings2 = useMemo(
    () => ({
      lazyLoad: "ondemand",
      dots: false,
      arrows: false,
      slidesToShow: 6,
      infinite: true,
      autoplay: true,
      slidesToScroll: 1,
      pauseOnHover: false,
      cssEase: "linear",
      autoplaySpeed: 0,
      speed: 5000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    }),
    []
  );

  return (
    <section className={`Lyft-teamlogo ${newClass}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {heading && (
              <span className="team-logo-dynamic-head">Teamed up with awesome brands through the years.</span>
            )}
            <Slider className="teamlogo-slider" {...settings2}>
              {teamLogos.map((logo, index) => (
                <div key={index} className="teamlogo-box Lyft-teamlogo-box">
                  <div>
                    <img
                      width="240"
                      height="240"
                      src={logo}
                      alt={`team logo ${index + 1}`}
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
